export default "__VITE_PUBLIC_ASSET__96227b1c__"